import { AppError } from 'app/common/app-error';

export class NoTokenError extends AppError {}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/common/no-token-error.ts